import {useSearchParams, useNavigate, useLocation} from 'react-router-dom'
import {CreateUpdateForm} from 'template'

export default function Update() {
  const fields = [
    {name: 'sonama', label: 'Nama Satuan', type: 'text', required: true},
  ]

  const [searchParams] = useSearchParams()
  const uid = searchParams.get('dctid')
  const soid = searchParams.get('soid')
  const navigate = useNavigate()
  const location = useLocation()
  const initialData = location?.state?.item || ''

  const apiEndpoint = `${
    process.env.REACT_APP_BASE_URL_DOKTER
  }/prd-data-satuan/${!!initialData ? 'update' : 'create'}`

  const apiParams = !!initialData ? {soid, soaktif: 1} : {}

  return (
    <>
      <CreateUpdateForm
        fields={fields}
        apiEndpoint={apiEndpoint}
        initialData={initialData || ''}
        label={initialData ? 'Ubah Data Satuan' : 'Tambah Data Satuan'}
        apiParams={{uid, reg: 'dbdok', a: 'dk13', ...apiParams}}
        onSuccess={() => navigate('/prd-data-satuan-obat?dctid=' + uid)}
        onCancel={() => navigate('/prd-data-satuan-obat?dctid=' + uid)}
      />
    </>
  )
}
